import React, { useEffect, useState } from 'react';

import { Col, Card, Row, Typography, Modal, Skeleton, Badge } from 'antd';
import { Link } from 'react-router-dom';

import './style.scss';
import { catchException, getLocalStorage } from '../../utils/helpers/helpers';
import {
  getIndicatorData,
  indicatorsDetailsTable,
} from '../../api/module/home';
import INTERNAL_LINKS from '../../enums/InternalLinks';
import AjaxTable from '../AjaxTable';

const { Title } = Typography;

const indicatorsBase = [
  {
    title: 'Validación Documentos Precontractuales',
    dataIndex: 'vdp',
    colorText: 'rgb(255, 216, 0)',
    colorNumber: 'rgb(255, 216, 0)',
    colorCard: 'rgba(255, 216, 0, 0.2)',
    link: (record) =>
      `${INTERNAL_LINKS.DOCUMENT_VALIDATION_PRECONTRACTUAL}/project=${record.id}`,
  },
  {
    title: 'Validación Documentos Jurídico',
    dataIndex: 'vdj',
    colorText: 'rgb(205, 90, 155)',
    colorNumber: 'rgb(205, 90, 155)',
    colorCard: 'rgba(205, 90, 155, 0.2)',
    link: (record) =>
      `${INTERNAL_LINKS.DOCUMENT_VALIDATION_CONTRACTUAL}/project=${record.id}`,
  },
  {
    title: 'Seguimiento Validación Documental',
    dataIndex: 'svdp',
    colorText: 'rgb(150, 125, 185)',
    colorNumber: 'rgb(150, 125, 185)',
    colorCard: 'rgba(150, 125, 185, 0.2)',
    link: (record) =>
      `${INTERNAL_LINKS.DOCUMENT_VALIDATION_PARTIAL}/project=${record.id}`,
  },
  {
    title: 'Aprobación Términos de referencia - TDR',
    dataIndex: 'tdr',
    colorText: 'rgb(150, 125, 185)',
    colorNumber: 'rgb(150, 125, 185)',
    colorCard: 'rgba(150, 125, 185, 0.2)',
    link: (record) => `${INTERNAL_LINKS.TDR_HOME}/${record.id}`,
  },
  {
    title: 'Firma de Términos de referencia',
    dataIndex: 'vdd',
    colorText: 'rgb(205, 90, 155)',
    colorNumber: 'rgb(205, 90, 155)',
    colorCard: 'rgba(205, 90, 155, 0.2)',
    link: (record) =>
      `${INTERNAL_LINKS.DOCUMENT_VALIDATION_DIRECTOR}/project=${record.id}`,
  },
  {
    title: 'Aprobación de productos',
    dataIndex: 'pa',
    colorText: 'rgb(40, 170, 225)',
    colorNumber: 'rgb(40, 170, 225)',
    colorCard: 'rgba(40, 170, 225, 0.2)',
    link: (record) => `${INTERNAL_LINKS.PRODUCT_APPROVAL}/project=${record.id}`,
  },
  {
    title: 'Aprobación Modificaciones contractuales',
    dataIndex: 'ctm',
    colorText: 'rgb(160, 200, 100)',
    colorNumber: 'rgb(160, 200, 100)',
    colorCard: 'rgba(160, 200, 100, 0.2)',
    link: (record) =>
      `${INTERNAL_LINKS.CONTRACT_MODIFICATIONS}/project=${record.id}`,
  },
  {
    title: 'Rechazos TDR y Modificaciones contractuales',
    dataIndex: 'rr',
    colorText: 'rgb(0, 160, 155)',
    colorNumber: 'rgb(0, 160, 155)',
    colorCard: 'rgba(0, 160, 155, 0.2)',
    link: (record) => `${INTERNAL_LINKS.REJECT_TDR}/pending/${record.id}`,
  },
  {
    title: 'Firma de Modificaciones contractuales',
    dataIndex: 'fctm',
    colorText: 'rgb(240, 80, 95)',
    colorNumber: 'rgb(240, 80, 95)',
    colorCard: 'rgba(240, 80, 95, 0.2)',
    link: (record) =>
      `${INTERNAL_LINKS.MODIFICATION_DIRECTOR}/project=${record.id}`,
  },
  {
    title: 'Revisión Pólizas',
    dataIndex: 'ip',
    colorText: 'rgb(204, 173, 0)', // 20% less brightness
    colorNumber: 'rgb(204, 173, 0)', // 20% less brightness
    colorCard: 'rgba(255, 216, 0, 0.2)',
    link: (record) => `${INTERNAL_LINKS.INSURANCE}/review/${record.id}`,
  },
  {
    title: 'Aprobación Poscontractual',
    dataIndex: 'pc',
    colorText: 'rgb(240, 140, 160)',
    colorNumber: 'rgb(240, 140, 160)',
    colorCard: 'rgba(240, 140, 160, 0.2)',
    link: (record) => `${INTERNAL_LINKS.POSTCONTRACTUAL}/0/${record.id}`,
  },
  {
    title: 'Firma Poscontractual',
    dataIndex: 'fpc',
    colorText: 'rgb(40, 170, 225)',
    colorNumber: 'rgb(40, 170, 225)',
    colorCard: 'rgba(40, 170, 225, 0.2)',
    link: (record) =>
      `${INTERNAL_LINKS.POSTCONTRACTUAL_DIRECTOR}/project=${record.id}`,
  },
  {
    title: 'Seguimiento Poscontractual',
    dataIndex: 'spc',
    colorText: 'rgb(230, 170, 100)',
    colorNumber: 'rgb(230, 170, 100)',
    colorCard: 'rgba(230, 170, 100, 0.2)',
    columns: [
      {
        title: 'Proyecto',
        dataIndex: 'nombre',
      },
      {
        title: 'Estado',
        dataIndex: 'prioridad_nombre',
      },
      { title: '#', dataIndex: 'n', align: 'center' },
      {
        title: 'Acciones',
        key: 'acciones',
        width: '3rem',
        align: 'center',
        render: (record) => (
          <Link
            to={`${INTERNAL_LINKS.POSTCONTRACTUAL_FOLLOWUP}/?proyecto=${record.id}&prioridad=${record.prioridad_nombre}`}
          >
            Ir
          </Link>
        ),
      },
    ],
  },
];

const HomeIndicators = () => {
  const [data, setData] = useState(undefined);

  const [mT, setMT] = useState();

  useEffect(() => {
    let isMounted = true;
    async function fetchData() {
      try {
        const res = await getIndicatorData();
        if (isMounted) setData(res.data);
      } catch (error) {
        catchException(error);
      }
    }
    fetchData();
    return () => {
      isMounted = false;
    };
  }, []);

  function handleClick(item) {
    setMT(item.dataIndex);
  }

  if (!data) {
    return <Skeleton loading={true} active={true} />;
  }

  return (
    <Card
      size={'small'}
      variant="borderless"
      title={<Title level={3}>Como ROL SIGA: {getLocalStorage('role')}</Title>}
    >
      <div id="homeIndicators">
        <Row justify="start" style={{ width: '100%' }} gutter={[8, 16]}>
          {indicatorsBase.map(
            (item, key) =>
              data.hasOwnProperty(item.dataIndex) && (
                <Col style={{ display: 'flex' }} md={8} xs={24} key={key}>
                  <Card
                    className="flexible-card"
                    // style={{ background: item.colorCard }}
                    onClick={() => handleClick(item)}
                    hoverable
                  >
                    <Card.Meta
                      title={
                        <div
                          style={{
                            display: 'flex',
                            // justifyContent: 'space-between',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <Title
                            level={4}
                            style={{
                              // color: item.colorText,
                              marginBottom: '1px',
                              marginTop: '1px',
                              fontWeight: 'normal',
                              width: '100%',
                            }}
                          >
                            <div
                              style={{
                                color: 'black',
                              }}
                            >
                              {item.title}
                            </div>
                          </Title>
                          <Badge
                            showZero
                            count={data[item.dataIndex] || 0}
                            color={item.colorNumber}
                            style={{
                              fontSize: '22px',
                              minWidth: '32px',
                              lineHeight: '32px',
                              height: '32px',
                              borderRadius: '16px',
                              paddingRight: '5px',
                              paddingLeft: '5px',
                              marginTop: '11px',
                              marginBottom: '11px',
                            }}
                          />
                        </div>
                      }
                    />
                  </Card>
                  <Modal
                    open={mT === item.dataIndex}
                    footer={null}
                    title={item.title}
                    onCancel={() => setMT()}
                    destroyOnClose
                    styles={{
                      body: {
                        paddingTop: '0px',
                      },
                    }}
                    width={'40%'}
                  >
                    <AjaxTable
                      tableTitle="Proyectos con pendientes"
                      endpoint={async (
                        _query,
                        page,
                        pageSize,
                        _sortby,
                        search,
                      ) => {
                        return await indicatorsDetailsTable(
                          item.dataIndex,
                          page,
                          pageSize,
                          search,
                        );
                      }}
                      columns={
                        item.columns || [
                          {
                            title: 'Proyecto',
                            dataIndex: 'nombre',
                          },
                          { title: '#', dataIndex: 'n', align: 'center' },
                          {
                            title: 'Acciones',
                            key: 'acciones',
                            width: '3rem',
                            align: 'center',
                            render: (record) => (
                              <Link to={item.link(record)}>Ir</Link>
                            ),
                          },
                        ]
                      }
                      searchInput
                    />
                  </Modal>
                </Col>
              ),
          )}
        </Row>
      </div>
    </Card>
  );
};

export default HomeIndicators;
